import { render, staticRenderFns } from "./mobile_register_form.vue?vue&type=template&id=6d0529b4&scoped=true&"
import script from "./mobile_register_form.vue?vue&type=script&lang=js&"
export * from "./mobile_register_form.vue?vue&type=script&lang=js&"
import style0 from "./mobile_register_form.vue?vue&type=style&index=0&id=6d0529b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0529b4",
  null
  
)

export default component.exports